<template>
	<div>
    <div class="columns">
      <FormulierVoeToe></FormulierVoeToe>
    </div>
	</div>
</template>

<script>
import SideView from './SideView.vue'
import FormulierVoeToe from './FormulierVoeToe.vue'

export default {
  name: 'Voegtoe',
  data () {
    return {
    }
  },

  mounted() {
  	
  },

  components: {
    SideView, FormulierVoeToe
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Voegtoe.vue